export default "/images/vendor/flag-icons/flags/1x1/ua.svg?af1d11dab17044ee2036a635e89196cd";